import { Tooltip, icons } from '@lifebit-ai/lds'
import React from 'react'

import { StyledLoader } from 'modules/resultsV2/DownloadResultFile.styles'
import { useDownloadParticipantFile } from 'services/results/hooks/useDownloadParticipantFile'

import * as styles from './DownloadParticipantFile.styles'

export const DOWNLOAD_PARTICIPANT_FILE_TEST_ID = 'download-participant-file'
export const DOWNLOAD_PARTICIPANT_FILE_LABEL = 'Download person ID file'

interface DownloadParticipantFileProps {
  resultId: string
}

const DownloadParticipantFile = ({ resultId }: DownloadParticipantFileProps): JSX.Element => {
  const mutation = useDownloadParticipantFile()
  const isLoading = mutation.isPending

  return (
    <Tooltip title="Download file">
      <styles.DownloadButton
        type="button"
        aria-label={DOWNLOAD_PARTICIPANT_FILE_LABEL}
        aria-busy={isLoading}
        aria-disabled={isLoading}
        disabled={isLoading}
        data-testid={DOWNLOAD_PARTICIPANT_FILE_TEST_ID}
        onClick={() => mutation.mutate({ resultId })}
      >
        {isLoading ? <StyledLoader text={false} /> : <icons.DownloadSmall />}
      </styles.DownloadButton>
    </Tooltip>
  )
}

export default DownloadParticipantFile
